
import { Component, Prop, Ref, Vue } from "vue-property-decorator"
import { BFormTextarea } from "bootstrap-vue"

import RichTextEditor from "./RichTextEditor.vue"

@Component({
	components: {
		"rich-text": RichTextEditor
	}
})
export default class TextAreaToggleExpand extends Vue {
	/**
	 * The maximum number of rows to show when not expanded
	 */
	@Prop({ type: Number, default: 8 })
	public unexpandedMaxRows!: number;

	/**
	 * The minimum number of rows to show
	 * Anything <2 will be set to 2
	 * @see https://bootstrap-vue.org/docs/components/form-textarea#displayed-rows
	 */
	@Prop({ type: Number, default: 2 })
	public minRows!: number;

	/**
	 * Value for v-model support
	 */
	@Prop({ type: String, default: "" })
	public value!: string;

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ default: () => null })
	public placeholder!: string | null

	@Prop({ default: false })
	public allowRichText!: boolean

	@Prop({ type: String, default: "" })
	public id!: string

	@Prop({ type: String, default: "" })
	public caseId!: string

	@Ref()
	textArea!: BFormTextarea

	private isExpanded = false;
	private readonly rowHeight = 19.5

	private set text (text: string) {
		this.$emit("input", text)
	}

	private get text () {
		return this.value
	}

	private get maxRows () {
		if (this.isExpanded) {
			const docHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			return Math.floor(docHeight / this.rowHeight) - 8 // 8 rows accounts for top/bottom bars in case creation
		}
		return this.unexpandedMaxRows
	}

	private get iconClass () {
		if (this.isExpanded) {
			return "fas fa-compress-alt"
		}
		return "fas fa-expand-alt"
	}

	private get richTextStyle (): any {
		return this.isExpanded
			? {}
			: {
				"max-height": "300px"
			}
	}

	private toggleExpanded () {
		this.isExpanded = !this.isExpanded

		this.forceTextAreaHeight()
	}

	/**
	 * Forces the bootstrap text-area to re-render
	 * @private
	 */
	private forceTextAreaHeight (): void {
		// From https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/src/components/form-textarea/form-textarea.js
		// setHeight calculates the height of the text area on the next tick
		this.textArea.setHeight()
	}
}
